// src/App.js
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';
import theme from './theme';
import AppRouter from './AppRouter';

import { AuthProvider } from './contexts/AuthContext';
import { RoleProvider } from './contexts/RoleContext';
import { NotificacaoProvider } from './contexts/NotificacaoContext';
import { PlanosPagamentoProvider } from './contexts/PlanosPagamentoContext';
import { PagamentosProvider } from './contexts/PagamentosContext';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
        <Router>
          {/* AuthProvider precisa vir primeiro */}
          <AuthProvider>
            {/* RoleProvider vem depois do AuthProvider */}
            <RoleProvider>
              <NotificacaoProvider>
                <PlanosPagamentoProvider>
                  <PagamentosProvider>
                    <AppRouter />
                  </PagamentosProvider>
                </PlanosPagamentoProvider>
              </NotificacaoProvider>
            </RoleProvider>
          </AuthProvider>
        </Router>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
